import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40577a8f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "left-hud large"
}
const _hoisted_2 = {
  key: 2,
  class: "alert alert-danger send-error-display text-center"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("We haven't tried to save for several minutes.")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("This might be nothing, but if you're making changes then there may be a problem.")
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_trip_viewer = _resolveComponent("trip-viewer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.selectedTrip)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Loading..."))
      : _createCommentVNode("", true),
    (_ctx.selectedTrip != null)
      ? (_openBlock(), _createBlock(_component_trip_viewer, {
          key: 1,
          modelValue: _ctx.selectedTrip,
          "onUpdate:modelValue": _ctx.doTripUpdate,
          onBack: _ctx.goToSelection
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBack"]))
      : _createCommentVNode("", true),
    (_ctx.hadSendError)
      ? (_openBlock(), _createElementBlock("h4", _hoisted_2, "Could not save!"))
      : _createCommentVNode("", true),
    (_ctx.noActivity)
      ? (_openBlock(), _createElementBlock("h5", {
          key: 3,
          class: "alert alert-warning inactivity-display text-center",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resetActivity && _ctx.resetActivity(...args)), ["prevent"]))
        }, _hoisted_6))
      : _createCommentVNode("", true)
  ], 64))
}